/**
 * Frontend "Is In" Operator.
 *
 * Registers with the module registry to handle the `is_in` operator.
 * Splits the rule value by comma and checks if the source field's value
 * matches any of the individual values.
 *
 * @package
 */

import { registerModule } from './module-registry';

// Register with the module registry on import.
registerModule({
	slug: 'operator-is-in',
	handles: (rule) => rule.operator === 'is_in',
	evaluate: (isMatch, formId, rule) => {
		// Split the comma-delimited value list and check each.
		const values = rule.value.split(',');

		for (const val of values) {
			const trimmed = val.trim();
			if (!trimmed) {
				continue;
			}

			const tempRule = {
				fieldId: rule.fieldId,
				operator: 'is',
				value: trimmed,
			};

			if (gf_is_match(formId, tempRule)) {
				return true;
			}
		}

		return isMatch;
	},
});
